function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { AlertDialogOverlay } from '@reach/alert-dialog';
import InnerDialog from './InnerDialog';
import { animateDuration } from './config';
var fadeIn = keyframes(["0%{opacity:0;}100%{opacity:1;}"]);
var fadeOut = keyframes(["0%{opacity:1;}100%{opacity:0;}"]);
var StyledAlertDialogOverlay = styled(AlertDialogOverlay).withConfig({
  displayName: "Dialog__StyledAlertDialogOverlay",
  componentId: "sc-1ml9zlv-0"
})(["position:fixed;top:0;left:0;background:", ";width:100%;height:100%;display:flex;justify-content:center;align-items:center;z-index:20;animation:", ";"], function (p) {
  return p.theme.colors.overlay;
}, function (props) {
  return props.$animatingOut ? css(["", " ", "ms forwards"], fadeOut, animateDuration) : css(["", " ", "ms forwards"], fadeIn, animateDuration);
});

var Dialog = function Dialog(props) {
  var leastDestructiveRef = React.useRef(null);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      animatingOut = _React$useState2[0],
      setAnimatingOut = _React$useState2[1];

  var open = props.open,
      prompt = props.prompt,
      cancel = props.cancel;

  if (!prompt || !open) {
    if (!prompt && process.env.NODE_ENV !== 'production') {
      console.warn('[Stash UI Dialog] No prompt provided to dialog, it will never display.');
    }

    return null;
  }

  var animatedCancel = function animatedCancel() {
    setAnimatingOut(true);
    setTimeout(function () {
      setAnimatingOut(false);
      cancel();
    }, animateDuration);
  };

  return /*#__PURE__*/React.createElement(StyledAlertDialogOverlay, {
    $animatingOut: animatingOut,
    leastDestructiveRef: leastDestructiveRef,
    onDismiss: function onDismiss(event) {
      if (event.type === 'click' && props.isClickableOutside === false) return;
      animatedCancel();
    }
  }, /*#__PURE__*/React.createElement(InnerDialog, _extends({}, props, {
    animatedCancel: animatedCancel,
    setAnimatingOut: setAnimatingOut,
    leastDestructiveRef: leastDestructiveRef
  })));
};

Dialog.propTypes = {
  /** Callback function for primary action */
  confirm: PropTypes.func,

  /** Callback function for secondary action */
  cancel: PropTypes.func,
  prompt: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Width of the dialog content */
  width: PropTypes.string,

  /** Controls whether dialog is shown or hidden */
  open: PropTypes.bool,

  /** Dialog heading specifically for emojis */
  emojiHeading: PropTypes.string,

  /** Aria label for emojiHeading */
  emojiHeadingLabel: PropTypes.string,

  /** Dialog heading (H1) */
  jumboHeading: PropTypes.string,

  /** Dialog heading (H3) */
  heading: PropTypes.string,

  /** Pass image src */
  align: PropTypes.oneOf(['left', 'center', 'right']),

  /** should a click on the backdrop close the modal? */
  isClickableOutside: PropTypes.bool,
  image: PropTypes.string,
  banksyImage: PropTypes.string,
  imageHeight: PropTypes.string,
  imageWidth: PropTypes.string,
  imageAlt: PropTypes.string,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,

  /** hide the primary cta */
  hideConfirmButton: PropTypes.bool,
  shouldRenderHelpLink: PropTypes.bool,
  needHelpLink: PropTypes.string
};
Dialog.defaultProps = {
  imageWidth: '8rem',
  isClickableOutside: true,
  imageAlt: '',
  confirmText: 'Continue',
  hideConfirmButton: false,
  shouldRenderHelpLink: true,
  needHelpLink: 'https://ask.stash.com',
  width: '30rem',
  align: 'center',
  confirm: function confirm() {},
  cancel: function cancel() {}
};
export default Dialog;